<template>
  <transition name="modal">
    <div class="modal-mask" @click="close">
      <div class="modal-wrapper">
        <div class="modal-container text-white">
          <div class="row align-items-center text-center justify-content-around">
            <img src="/static/images/close.svg" alt="" class="close-btn" @click="close">
            <span>謝謝您的填寫 我們會有專人與您盡快聯絡</span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    props: ["close_modal"],
    methods: {
      close() {
        this.$emit('endSubmit')
      }
    }
  }

</script>
<style>
  .modal-mask {
    position: fixed;
    z-index: 99999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    position: relative;
    width: 45%;
    margin: 0px auto;
    padding: 60px 20px;
    background-color: rgba(0, 0, 0, 1);
    border-radius: 25px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
  }

  .close-btn {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 15px;
    right: 15px;
    cursor: pointer;
  }



  /*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

</style>



// WEBPACK FOOTER //
// src/components/submitSuccess.vue